import { render } from "./QuickPreviewUser.vue?vue&type=template&id=0124d991"
import script from "./QuickPreviewUser.vue?vue&type=script&lang=js"
export * from "./QuickPreviewUser.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__